var exports = {
  "G": "ActivityViewRoot.module__frame___TjcwY3",
};

module.exports = exports;
